import {
    displayDynamicShippingAlert
} from './_displayDynamicShippingAlert';
import {
    doScrollToTop
} from '../global/_scroll';
import {
    scrollTo
} from '../../utils/_scrollTo';
const validPayment = (certificateValue, message,pinType) => {
    if (certificateValue == '') {
        displayDynamicShippingAlert(message, 'danger', pinType);
        //doScrollToTop();
        return false;
    }
    return true;
};

const validGiftCard = (certificateValue, message,pinType) => {
    if (certificateValue == '' || certificateValue.length < 10 || (!certificateValue.match(/^[4-6]/g) && !certificateValue.match(/^984000158.*/g))) {
        displayDynamicShippingAlert(message, 'danger', pinType);
        //doScrollToTop();
        return false;
    }
    return true;
};

const valGiftCard = (form) => {
    return validGiftCard(form.giftCertificate.value, '<span class="giftCardTxtMessage">Please enter a valid Gift Card number.</span>','giftCard');
};

const valPromoCode = (form) => {
    return validPayment(form.certificate1.value, '<span class="giftCardTxtMessage">Please enter a valid Rewards Certificate or Shopping Pass.</span>','rewardsCert');
};

const valBillAddress = (form) => {
    if (form.billingAddressId && form.billingAddressId.value != '') return true;
    displayDynamicShippingAlert('Please provide a valid billing address.', 'danger');
    return false;
};

const invalidAlert = (message) => {
    displayDynamicShippingAlert(message, 'danger');
    scrollTo("#messages")
}

const checkCCNo = (ccNo) => {
    var invalidCC1 = (ccNo) == null || (ccNo.value).length == 0,
        invalidCC2 = ccNo.value.search(/^\d+$/) == -1;
    if (invalidCC1 || invalidCC2) {
       // invalidAlert('Please provide complete and proper payment information.');
        try {
            $('#generic-error-message').remove();
            $(ccNo).parents('.form-group').removeClass('has-error').find('#credit-card-error-message').remove();
            $(ccNo).focus().parents('.form-group').addClass('has-error').append('<p class="help-block txt-error" id="credit-card-error-message">Please enter a valid credit card number.</p>');
            $(ccNo).on('input', function () {
                $(this).parents('.form-group').removeClass('has-error').find('#credit-card-error-message').remove();
            });
        }
        catch (err) {
           // document.getElementById("messages").innerHTML = err.message;
            $('#messages').append('<div data-twist="generic-error" id="generic-error-message" class="alert alert-danger" role="alert" aria-live="assertive"><div class="generic-error-display-message">A generic error has occurred.</div></div>');
        }


        return false;
    }

    return true;
};

const checkCVN2 = (cvn, brand) => {
    if ($('#expirationDateGroup').is(':visible') &&
        brand.trim() == "Dillards Charge") {
        brand = "Dillards AMEX Charge";
    }
    var cvnNull = cvn == null,
        amex = (brand.trim() == "Dillards AMEX Charge") || (brand.trim() == "AMEX"),
        discoverMasterCardVisaDillardsPrivateLabel = (brand.trim() == "VISA") || (brand.trim() == "Master Card") || (brand.trim() == "Discover") || (brand.trim() == "Dillards Charge") || (brand.trim() == "Dillards Mastercard")|| (brand.trim() == "Dillards Private Label"),
        cvnLT4 = (cvn.value).length < 4,
        cvnNE3 = (cvn.value).length != 3,
        cvnLT3 = (cvn.value).length < 3,
        cc1 = amex && cvnLT4,
        cc2 = discoverMasterCardVisaDillardsPrivateLabel && cvnNE3;
    if (cvnNull || cc1 || cc2 || cvnLT3) {
       // invalidAlert('Enter the Security Code as it appears on your card. For American Express Cards, use the four digit number on front of the card located above your account number. For all other cards, use the three digit number located on the back of your card. For more information, click the &#34;What&#39;s This?&#34; link next to the Security Code box.');
        try {
            $('#generic-error-message').remove();
            $(cvn).parents('.form-group').removeClass('has-error').find('#security-code-error-message').remove();
            $(cvn).focus().parents('.form-group.cvnInput').addClass('has-error').append('<p class="help-block txt-error" id="security-code-error-message">Please enter a valid security code.</p>');
            $(cvn).on('input', function () {
                $(this).parents('.form-group').removeClass('has-error').find('#security-code-error-message').remove();
            });
        }
        catch (err) {
            //document.getElementById("messages").innerHTML = err.message;
            $('#messages').append('<div data-twist="generic-error" id="generic-error-message" class="alert alert-danger" role="alert" aria-live="assertive"><div class="generic-error-display-message">A generic error has occurred.</div></div>');
        }

        return false;
    }
    if (cvn.value.search(/^\d+$/) == -1) {
        displayDynamicShippingAlert('Please enter a numeric value for Security Code.', 'danger');
        cvn.value = "";
        try {
            $('#generic-error-message').remove();
            $(cvn).parents('.form-group').removeClass('has-error').find('#security-code-error-message').remove();
            $(cvn).focus().parents('.form-group').addClass('has-error').append('<p class="help-block txt-error" id="security-code-error-message">Please enter a valid security code.</p>');
            $(cvn).on('input', function () {
                $(this).parents('.form-group').removeClass('has-error').find('#security-code-error-message').remove();
            });
        }
        catch (err) {
            //document.getElementById("messages").innerHTML = err.message;
            $('#messages').append('<div data-twist="generic-error" id="generic-error-message" class="alert alert-danger" role="alert" aria-live="assertive"><div class="generic-error-display-message">A generic error has occurred.</div></div>');
        }
        return false;
    }
    return true;
};

export {
    checkCCNo,
    checkCVN2,
    valBillAddress,
    valGiftCard,
    valPromoCode
}
